module.exports = __webpack_public_path__ + "assets/img/2.4735d0b6.jpg";